import { Box, Typography } from '@mui/material';
import { LwCheckbox } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { TakeDefined } from '@types';
import { translateRoleToDutch } from 'shared/utils/roles-utils';
import { useGetUserAsForm } from 'ogp/hooks/queryHooks/users/use-get-user';
import { useRolesMatrix } from 'ogp/hooks/queryHooks/users/use-roles-matrix';
import { UserFormProps } from './user-form.types';

export const UserFormLimitedCompanyRoles = ({
  matrix,
  defaultDepartmentId,
  state,
}: {
  matrix: TakeDefined<ReturnType<typeof useRolesMatrix>['data']>;
  defaultDepartmentId: string;
  state: UserFormProps['state'];
}) => {
  const { setValue, watch, getValues } =
    useFormContext<TakeDefined<ReturnType<typeof useGetUserAsForm>['data']>>();

  const departmentMatrix =
    matrix
      .flatMap((branchOffice) => branchOffice.departments)
      .find((d) => d.id === defaultDepartmentId)?.matrix ?? matrix[0]?.departments[0]?.matrix;

  if (!departmentMatrix?.length) {
    return null;
  }

  const departmentRoles = watch('roles.departmentRoles') ?? {};
  const currentValue = departmentRoles[defaultDepartmentId] ?? null;
  const identifier =
    `roles.departmentRoles.${defaultDepartmentId}` as `roles.departmentRoles.${string}`;

  return (
    <Box width="100%">
      <Box display="flex" flexDirection="row" paddingBottom={1}>
        <Box flex="3">
          <Typography variant="subtitle1">Vestiging rollen</Typography>
        </Box>
        {departmentMatrix.map((role) => (
          <Box key={role.name} display="flex" flex="1" justifyContent="center">
            <Typography variant="subtitle1">{translateRoleToDutch(role.name)}</Typography>
          </Box>
        ))}
      </Box>
      <Box display="flex" flexDirection="row" marginTop={4}>
        <Box flex="3" />
        {departmentMatrix.map((role) => (
          <Box key={role.name} flex="1" justifyContent="center" display="flex">
            <LwCheckbox
              name={identifier}
              title={role.name}
              checked={currentValue === role.role}
              onChange={(_, checked) => {
                setValue('roles.departmentRoles', {
                  ...(getValues('roles.departmentRoles') ?? {}),
                  [defaultDepartmentId]: checked ? role.role : null,
                });
              }}
              disabled={state === 'read' || !role.enabled}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
